import map from 'ramda/src/map'

export default onEnterActions => async dispatch => Promise.all(
	map(({ action, payloads }) => {
		map(payload => dispatch(action(payload)), payloads)
	}, onEnterActions),
)
